// Tickable Mail texts, one file per area so the areas can be edited apart.
import common from "./common.en"
import editor from "./editor.en"
import flows from "./flows.en"
import campaigns from "./campaigns.en"
import inbox from "./inbox.en"

export default { ...common, ...editor, ...flows, ...campaigns, ...inbox }
